import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListRentalComponent } from './list-rental/list-rental.component';

const routes: Routes = [
  {
    path: '',
    component: ListRentalComponent,
  },
  { path: '', pathMatch: 'full', redirectTo: 'admin/rental' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRentalRoutingModule {}
